"use client";

import { createContext } from "react";

const WebpContext = createContext({
  canUseWebp: true,
  setCanUseWebp: () => {},
});

export default WebpContext;
